<div class="crisis-card" *ngIf="isCrisis">
  <h4 class="crisis-title">You are not alone</h4>
  <p class="crisis-text">
    Dealing with a health condition can be exhausting.
    If things feel too heavy, talking to a trained counsellor can help.
    iCall is free, confidential, and available across India.
  </p>
  <button
    type="button"
    class="icall-btn"
    (click)="callICall()"
    aria-label="Call iCall helpline: 9152987821"
  >
    <span class="icall-icon" aria-hidden="true">☎</span>
    <span class="icall-copy">
      <span class="icall-name">iCall - 9152987821</span>
      <span class="icall-sub">Free · Mon-Sat 8am-10pm · Confidential</span>
    </span>
  </button>
</div>
